import isDefined from '@automator/utilities/is-defined';

/**
 * Animates the height of the matched elements. This causes lower parts of the page
 * to slide up, hiding the content.
 *
 * @param {Node}     $element           The element to animate
 * @param {Integer}  options.duration   The duration, in ms
 * @param {Function} options.onComplete Callback invoked when the animation is completed
 * @return {undefined}
 */
const slideUp = ( $element, { duration, onComplete } ) => {
	// Check if there is a custom duration defined
	if ( isDefined( duration ) ) {
		$element.style.transitionDuration = `${duration}ms`;
	}

	// Get the height
	const height = `${$element.clientHeight}px`;

	// Set the height to { height } to prepare the element for the transition
	$element.style.height = height;

	setTimeout( () => {
		// Set the height to 0
		$element.style.height = '0px';

		$element.addEventListener(
			'transitionend',
			() => {
				// Once finished, hide the element
				$element.style.display = 'none';

				// Remove the height property
				$element.style.removeProperty( 'height' );

				// Check if there is a custom duration defined
				if ( isDefined( duration ) ) {
					$element.style.removeProperty( 'transition-duration' );
				}

				// Check if there is a callback defined
				if ( isDefined( onComplete ) ) {
					try {
						onComplete();
					} catch ( e ) {}
				}
			},
			{
				// Invoke only once
				once: true,
			}
		);
	}, 0 );
};

export default slideUp;
